import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ticketsService from '../../services/ticketsService';
import { Grid, Container, Button } from '@mui/material';
import { FlexAlerts, AlertSeverityTypes } from '../../components/Message/Alerts/Alerts';
import { Topheader } from '../../components/Topheader';
import TableV2, { spreadPaginationOptions } from '../../components/Table/TableV2';
import classes from './Tickets.module.scss';
import Tooltip from '@mui/material/Tooltip';
import FeatureFlag from '../../components/FeatureFlag/FeatureFlag';
import FeatureFlagButtonDisabler from '../../components/FeatureFlagButtonDisabler/FeatureFlagButtonDisabler';

const TicketsTable = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [isUserAllowedToExport, setIsUserAllowedToExport] = useState(false);
  const [messages, setMessages] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    let user = localStorage.getItem('user');
    user = JSON.parse(user) || {};
    setIsUserAllowedToExport(user?.role <= 1 || !!user?.permissions?.exportRecord);
  }, []);

  const getTickets = (paginationOptions) => {
    const query = spreadPaginationOptions(paginationOptions);

    setIsLoading(true);
    ticketsService
      .getTicketsList(query)
      .then((response) => {
        if (response.data) {
          setTickets(response.data?.tickets);
          setRowCount(response.data?.rowCount);
        }
      })
      .catch((error) => {
        setMessages([
          {
            message: `Could not retrieve tickets. ${error?.response?.data?.message ?? ''}`,
            severity: AlertSeverityTypes.error,
          },
        ]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const openTicket = (id) => {
    history.push('/AddTickets/?ticket=' + id);
  };

  const handleAddTicket = () => {
    history.push('/AddTickets');
  };

  const columns = [
    {
      field: 'ticketNumber',
      type: 'string',
      headerName: 'Id',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => (
        <Tooltip title="View Ticket">
          <span className={classes.Underline} onClick={(_e) => openTicket(params.value)}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    { field: 'email', type: 'string', headerName: 'Email', minWidth: 175, flex: 1 },
    { field: 'phone', type: 'string', headerName: 'Phone', minWidth: 120, flex: 1 },
    {
      field: 'status',
      type: 'boolean',
      headerName: 'Ticket Status',
      minWidth: 130,
      flex: 1,
      renderCell: (params) =>
        params.value ? (
          <button type="button" className="btn paidBtn">
            Closed
          </button>
        ) : (
          <button type="button" className="btn RefundedBtn">
            Open
          </button>
        ),
    },
    {
      field: 'issue',
      type: 'string',
      headerName: 'Issue',
      minWidth: 250,
      flex: 3,
    },
    {
      field: 'createdDate',
      type: 'dateTime',
      headerName: 'Date',
      minWidth: 175,
      flex: 1,
      valueGetter: (value) => new Date(value),
      valueFormatter: (value) => new Date(value).toLocaleString(),
    },
  ];

  return (
    <div className="rightPanel">
      <Topheader />
      <div className="contentPart">
        <Container
          component="main"
          maxWidth={false}
          sx={{ marginBottom: '40px' }}
          className="terminal-container term-add"
        >
          <FeatureFlag name="ticket:write" />
          <Grid container rowSpacing={2}>
            <Grid item xs={12} />
            <Grid item xs={12}>
              <h3 className="terminal-title">Tickets</h3>
            </Grid>
            <Grid item xs={12}>
              <FlexAlerts messages={messages} />
            </Grid>
            <Grid item xs={12}>
              <TableV2
                rows={tickets}
                columns={columns}
                fetchData={getTickets}
                rowCount={rowCount}
                isLoading={isLoading}
                defaultSortColumn="createdDate"
                dateConfig={{ isDateFiltering: true, defaultFromDateDays: 30 }}
                isExportable={isUserAllowedToExport}
                searchConfig={{ isSearchBar: true }}
                toolbarExtension={
                  <FeatureFlagButtonDisabler name="ticket:write">
                    <Button id="add-ticket-button" onClick={handleAddTicket}>
                      Add Ticket
                    </Button>
                  </FeatureFlagButtonDisabler>
                }
              />
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

export default TicketsTable;
